import './Base.css'
import './Header.css'

function Header() {
    return (
        <header className="center">
        <div className="header-content">
            <div className="logo center">
                <img src="images/logo.png" alt="网站Logo" width="55px" height="38px"/>
            </div>
            <div className="logo-title vertical-center">
                未来通
            </div>
            <div className="nav-menu vertical-center">
                <ul>
                    <li><a href="/index.html">ホーム</a></li>
                    <li>企業情報</li>
                    <li>サービス</li>
                    <li>お問い合わせ</li>
                </ul>
            </div>
        </div>
    </header>
    );
}

export default Header;